import { useCallback, useState } from 'react';
import { SetupOrgOnboardingSteps } from '@sdk/authentication/types';

type StepsProps = {
  steps: SetupOrgOnboardingSteps[];
  onNextStep?: (activeStep: SetupOrgOnboardingSteps, targetStep: SetupOrgOnboardingSteps) => void;
};

export const useSteps = ({ steps, onNextStep }: StepsProps) => {
  const [activeStep, setActiveStep] = useState<SetupOrgOnboardingSteps>();

  const nextStep = useCallback(
    (step: SetupOrgOnboardingSteps = undefined): void => {
      let targetStep: SetupOrgOnboardingSteps = step;

      if (!targetStep) {
        targetStep = steps[activeStep ? steps.findIndex((s) => s === activeStep) + 1 : 0];
      }

      setActiveStep(targetStep);

      if (onNextStep) {
        onNextStep(activeStep, targetStep);
      }
    },
    [steps, activeStep, onNextStep]
  );

  return {
    activeStep,
    nextStep,
  };
};
